"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../types");
const BAD_REQUEST_CODE = "BAD_REQUEST";
const PAGE_NOTFOUND_CODE = "PAGE_NOTFOUND";
function getErrorText(error) {
    let text = error.message;
    const field = /[^.]+$/.exec(error.propertyPath || "");
    if (field)
        text = `Field ${field[0]}: ${text}`;
    return text;
}
function apiErrorHandler(e, errorCB) {
    e.forEach(error => errorCB(types_1.EVENT_NAMES.REQUEST_STATUS, error));
}
exports.apiErrorHandler = apiErrorHandler;
function getApiErrors(e) {
    if ((!e.graphQLErrors || e.graphQLErrors.length === 0) && !e.networkError) {
        return [{ message: "Internal error", status: "error", code: "UNKNOWN_ERROR", error: e }];
    }
    const result = [];
    e.graphQLErrors.forEach(graphqlError => {
        var _a, _b, _c, _d;
        let deliverErrors = [
            {
                message: "Internal Error",
                status: "error",
                code: ((_a = graphqlError.extensions) === null || _a === void 0 ? void 0 : _a.code) || "UNKNOWN_ERROR",
                error: graphqlError,
            },
        ];
        if (graphqlError.extensions && graphqlError.extensions.code) {
            if (graphqlError.extensions.code === BAD_REQUEST_CODE && ((_c = (_b = graphqlError.extensions.exception) === null || _b === void 0 ? void 0 : _b.additionalData) === null || _c === void 0 ? void 0 : _c.errors)) {
                const apiErrors = graphqlError.extensions.exception.additionalData.errors;
                if (apiErrors && apiErrors.length > 0) {
                    deliverErrors = apiErrors.map(apiError => ({
                        message: getErrorText(apiError),
                        status: "error",
                        code: "BAD_REQUEST",
                        details: apiError,
                        error: graphqlError,
                    }));
                }
            }
            else if (graphqlError.extensions.code === PAGE_NOTFOUND_CODE && ((_d = graphqlError.extensions.exception) === null || _d === void 0 ? void 0 : _d.additionalData)) {
                const apiError = graphqlError.extensions.exception.additionalData;
                deliverErrors = [
                    {
                        message: apiError,
                        status: "error",
                        code: "NOTFOUND",
                        error: graphqlError,
                    },
                ];
            }
        }
        result.push(...deliverErrors);
    });
    if (e.networkError) {
        result.push({ message: "Internal error", status: "error", code: "UNKNOWN_ERROR", error: e.networkError });
    }
    return result;
}
exports.getApiErrors = getApiErrors;
//# sourceMappingURL=apiErrorHandler.js.map